export function selectAnnouncement(active, fallback, expiresAt, now = Date.now()) {
  if (!expiresAt) return active;
  const expires = Date.parse(expiresAt);
  return Number.isFinite(expires) && now < expires ? active : fallback;
}

if (typeof customElements !== 'undefined' && !customElements.get('wachstoria-announcements')) {
  customElements.define('wachstoria-announcements', class extends HTMLElement {
    connectedCallback() {
      this.refresh();
      this.timer = setInterval(() => this.refresh(), 1000);
      this.toggle = this.querySelector('.ws-announcements__toggle');
      this.onToggle = () => {
        const paused = this.toggleAttribute('data-paused');
        this.toggle.setAttribute('aria-pressed', String(paused));
        this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      };
      this.toggle?.addEventListener('click', this.onToggle);
    }
    refresh() {
      const now = Date.now();
      this.querySelectorAll('[data-ws-announcement]').forEach(item => {
        const text = selectAnnouncement(item.dataset.active, item.dataset.fallback, item.dataset.expires, now);
        if (item.textContent !== text) item.textContent = text;
      });
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.toggle?.removeEventListener('click', this.onToggle);
    }
  });
}
